<template>
  <el-dialog :visible.sync="visible" :title="dialogTitle" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" :custom-class="noticeData && noticeData.notice_type === 1? 'custom-notice-dialog-beief':'custom-notice-dialog'">
    <div class="notice-content">
      <div v-if="noticeData" class="notice-body">
        <div v-if="noticeData.content" v-html="noticeData.content"></div>
        <p v-else>系统通知</p>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" type="primary" @click="handleConfirm">
        确定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SystemNoticeDialog',

  data() {
    return {
      visible: false
    }
  },

  computed: {
    ...mapGetters('globalCheck', ['currentDialog', 'noticeData']),

    dialogTitle() {
      return this.noticeData ? this.noticeData.title : '系统通知'
    }
  },

  watch: {
    currentDialog: {
      handler(newVal) {
        if (newVal === 'notice') {
          this.visible = true
        } else {
          this.visible = false
        }
      },
      immediate: true
    }
  },

  methods: {
    handleConfirm() {
      this.visible = false
      // 设置sessionStorage，本次登录期间不再弹出
      sessionStorage.setItem('updateNoticeStorage', 'false')
      // 通知全局状态管理器弹窗已显示完成
      this.$store.dispatch('globalCheck/handleDialogShown', 'notice')
    }
  }
}
</script>

<style scoped>
.notice-content {
  max-height: 50vh;
  overflow-y: auto;
}

.notice-body {
  line-height: 1.6;
  color: #333;
}

.dialog-footer {
  text-align: right;
}

/* 深度选择器修改dialog样式 */
::v-deep .custom-notice-dialog {
  width: 50%;
  border-radius: 10px;
}
::v-deep .custom-notice-dialog-beief {
  max-width: 500px;
  margin-top: 35vh !important;
}

::v-deep .custom-notice-dialog.custom-notice-dialog-beief .el-dialog__header {
  border-bottom: 1px solid #e9ecef;
}

::v-deep .custom-notice-dialog.custom-notice-dialog-beief .el-dialog__title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}
</style> 